import React, { useEffect, useState } from "react";
import { Modal, Popover, Table } from "antd";
import { Button } from "@mui/material";
import CommonPopup from "../../components/popup/CommonPopup";
import TextArea from "../../components/Form/TextArea";

const flattenData = (dataSource) => {
  const flattenedData = [];
  // dataSource.forEach((week) => {
  //   flattenedData.push({
  //     date: week.date,
  //     isDateRow: true,
  //   });
  //   week.data.forEach((item) => {
  //     flattenedData.push({
  //       ...item,
  //       isDateRow: false,
  //     });
  //   });
  // });
  return flattenedData;
};

const SummaryTable = ({
  dataSource,
  HandleReject,
  rejectReason,
  setRejectReason,
  isOpenReject,
  setisOpenReject,
}) => {
  const [flattenedData, setFlattenedData] = useState(dataSource);

  useEffect(() => {
    if (dataSource !== undefined) {
      setFlattenedData(dataSource);
    }
  }, [dataSource]);

  useEffect(() => {
    if (isOpenReject?.open == false) {
      setRejectReason("");
    }
  }, [isOpenReject?.open]);

  console.log("dataSource", flattenedData);

  const handleselReject = () => {
    setisOpenReject({ open: false, id: "", type: "" });
  };

  const columns = [
    // {
    //   title: null,
    //   dataIndex: "date",
    //   key: "date",
    //   align: "center",
    //   width: 0.1,
    //   render: (text, record) => {
    //     return {
    //       children: <span className="sticky-date">{text}</span>,
    //       props: {
    //         colSpan: record.isDateRow ? 7 : 1,
    //       },
    //     };
    //   },
    // },
    {
      title: "Application ID",
      dataIndex: "uniqueId",
      key: "id",
      width: 230,
      render: (_, record) => (
        <>
          <p>OAP-{record.uniqueId.toString().padStart(6, "0")}</p>
        </>
      ),
    },
    {
      title: "Veh/Chassis No. & Make/Model",
      dataIndex: "vehicle_details",
      key: "vehicle_details",
      width: 340,
      render: (_, record) => (
        <>
          <div className="table_veh_block">
            <p>{record.vehicle_details?.vehicle_reg_no}</p>
            <p>{record.vehicle_details?.make_model}</p>
          </div>
        </>
      ),
    },
    {
      title: "Loan Amt",
      dataIndex: "loanamount",
      key: "loanamount",
      width: 180,
      render: (_, record) => (
        <>
          <p>$ {record.loanamount}</p>
        </>
      ),
    },
    {
      title: "Loan Int",
      dataIndex: "interestinfo",
      key: "interestinfo",
      width: 180,
      render: (_, record) => (
        <>
          <p>{record.interestinfo?.interest} %</p>
        </>
      ),
    },
    {
      title: "Loan Product Name",
      dataIndex: "productinfo",
      key: "productinfo",
      width: 200,
      render: (_, record) => (
        <>
          <p>{record.productinfo?.name}</p>
        </>
      ),
    },
    {
      title: "Action",
      dataIndex: "Action",
      key: "Action",
      width: 160,
      align: "center",
      render: (_, record) => {
        if (!record.isDateRow) {
          return record.is_rejected == 1 ? (
            <div className="table_btn_block">
              <Popover content={record.reason} placement="top">
                <img
                  src="/images/fi_info.svg"
                  alt="info"
                  className="-ml-[35px]"
                />
              </Popover>
              <Button
                type="button"
                className={`rejected_btn ${record.isHovered ? "hovered" : ""}`}
                onMouseEnter={() => handleMouseEnter(record)}
                onMouseLeave={() => handleMouseLeave(record)}
                onClick={() => {
                  HandleReject(record?.is_rejected, record?.summary_id);
                }}
              >
                {record.isHovered ? "Undo" : "Rejected"}
              </Button>
            </div>
          ) : (
            <div className="table_btn_block">
              <Button
                type="button"
                className="reject_btn"
                onClick={() => {
                  console.log("REJECT RECORD", record);
                  setisOpenReject({
                    open: true,
                    id: record?.summary_id,
                    type: record?.is_rejected,
                  });
                }}
              >
                Reject
              </Button>
            </div>
          );
        }
        return null;
      },
    },
  ];

  console.log("flattenedData", flattenedData);

  const handleMouseEnter = (record) => {
    setFlattenedData((prevData) =>
      prevData.map((item) => ({
        ...item,
        isHovered: item === record,
      }))
    );
  };

  const handleMouseLeave = () => {
    setFlattenedData((prevData) =>
      prevData.map((item) => ({
        ...item,
        isHovered: false,
      }))
    );
  };

  const rowClassName = (record) => {
    return record.isDateRow ? "custom-date-row" : "";
  };

  return (
    <section className="table_section summary-table">
      {flattenedData !== undefined && (
        <Table
          dataSource={flattenedData}
          columns={columns}
          rowKey={(record, index) => `${record.date}-${index}`}
          scroll={{ x: "calc(700px + 50%)", y: 500 }}
          rowClassName={rowClassName}
          pagination={{ pageSize: 50 }}
        />
      )}
      <Modal
        open={isOpenReject?.open}
        onCancel={handleselReject}
        centered
        footer={null}
      >
        <div className="reject-popup-block">
          <h2 className="text-center">Reject</h2>
          <TextArea
            label="Remarks"
            placeholder="Reason to reject loan"
            value={rejectReason}
            onChange={(e) => {
              setRejectReason(e.target.value);
            }}
          />
          <div className="reject-popup-btn">
            <Button
              type="button"
              className="can_btn"
              onClick={() => {
                handleselReject();
              }}
            >
              Close
            </Button>
            <Button
              type="submit"
              className="sav_btn"
              disabled={rejectReason?.length < 1}
              onClick={() => {
                HandleReject(isOpenReject?.type, isOpenReject?.id);
              }}
            >
              Submit
            </Button>
          </div>
        </div>
      </Modal>
    </section>
  );
};

export default SummaryTable;
